import { space } from '../spacing.js';
export const buttonBase = {
    paddingY: space.x1,
    paddingX: space.x3,
};
export const buttonVariants = {
    primary: {
        inactive: {
            backgroundColor: 'primary',
            textColor: 'primaryOnDark',
            skeletonColor: 'primary',
            boxShadow: {
                alpha: 'x5',
                style: 'medium',
                color: 'primary',
            },
        },
        hovered: {
            backgroundColor: 'primaryHover',
            textColor: 'primaryOnDark',
            boxShadow: {
                alpha: 'x5',
                style: 'medium',
                color: 'primary',
            },
        },
        active: {
            backgroundColor: 'primaryActive',
        },
        pressed: {
            backgroundColor: 'primary',
            border: 'primaryActive',
        },
        focused: {
            backgroundColor: 'primaryHover',
            textColor: 'primaryOnDark',
        },
    },
    secondary: {
        inactive: {
            backgroundColor: 'secondary',
            textColor: 'default',
            skeletonColor: 'secondary',
        },
        hovered: {
            backgroundColor: 'secondaryHover',
        },
        active: {
            backgroundColor: 'secondaryActive',
        },
        pressed: {
            border: 'primary',
        },
        focused: {
            backgroundColor: 'secondaryHover',
        },
    },
    secondaryAccent: {
        inactive: {
            backgroundColor: 'secondaryAccent',
            textColor: 'primary',
            skeletonColor: 'secondaryAccent',
        },
        hovered: {
            backgroundColor: 'primaryHover',
            textColor: 'primaryOnDark',
        },
        active: {
            backgroundColor: 'primaryActive',
            textColor: 'primaryOnDark',
        },
        pressed: {
            border: 'primary',
        },
        focused: {
            backgroundColor: 'primaryHover',
            textColor: 'primaryOnDark',
        },
    },
    subtle: {
        inactive: {
            backgroundColor: 'subtle',
            textColor: 'default',
            skeletonColor: 'subtle',
        },
        hovered: {
            backgroundColor: 'subtleHover',
        },
        active: {
            backgroundColor: 'subtleActive',
        },
        pressed: {
            backgroundColor: 'secondary',
            border: 'primary',
        },
        focused: {
            backgroundColor: 'subtleHover',
        },
    },
    secondaryOnGray: {
        inactive: {
            backgroundColor: 'secondaryOnGray',
            textColor: 'default',
            skeletonColor: 'secondaryOnGray',
        },
        hovered: {
            backgroundColor: 'secondaryHover',
        },
        active: {
            backgroundColor: 'secondaryActive',
        },
        pressed: {
            border: 'primary',
        },
        focused: {
            backgroundColor: 'secondaryHover',
        },
    },
    primaryDestructive: {
        inactive: {
            backgroundColor: 'destructive',
            textColor: 'errorOnDark',
            skeletonColor: 'destructive',
            boxShadow: {
                alpha: 'x5',
                style: 'medium',
                color: 'primaryDestructive',
            },
        },
        hovered: {
            backgroundColor: 'destructiveHover',
            boxShadow: {
                alpha: 'x5',
                style: 'medium',
                color: 'primaryDestructive',
            },
        },
        active: {
            backgroundColor: 'destructiveActive',
        },
        pressed: {
            border: 'errorActive',
        },
        focused: {
            backgroundColor: 'destructiveHover',
        },
    },
    secondaryDestructive: {
        inactive: {
            backgroundColor: 'secondaryDestructive',
            textColor: 'error',
            skeletonColor: 'secondaryDestructive',
        },
        hovered: {
            backgroundColor: 'destructiveHover',
            textColor: 'errorOnDark',
        },
        active: {
            backgroundColor: 'destructiveActive',
            textColor: 'errorOnDark',
        },
        pressed: {
            border: 'primary',
        },
        focused: {
            backgroundColor: 'destructiveHover',
            textColor: 'errorOnDark',
        },
    },
    subtleDestructive: {
        inactive: {
            backgroundColor: 'subtleDestructive',
            textColor: 'error',
            skeletonColor: 'subtleDestructive',
        },
        hovered: {
            backgroundColor: 'subtleDestructiveHover',
            textColor: 'errorOnDark',
        },
        active: {
            backgroundColor: 'subtleDestructiveActive',
            textColor: 'errorOnDark',
        },
        pressed: {
            backgroundColor: 'secondaryDestructive',
            border: 'primary',
        },
        focused: {
            backgroundColor: 'subtleDestructiveHover',
            textColor: 'errorOnDark',
        },
    },
    activation: {
        inactive: {
            backgroundColor: 'activation',
            textColor: 'activationOnDark',
            skeletonColor: 'activation',
            boxShadow: {
                alpha: 'x5',
                style: 'medium',
                color: 'activation',
            },
        },
        hovered: {
            backgroundColor: 'activationHover',
            textColor: 'activationOnDark',
            boxShadow: {
                alpha: 'x5',
                style: 'medium',
                color: 'activation',
            },
        },
        active: {
            backgroundColor: 'activationActive',
            textColor: 'activationOnDark',
        },
        pressed: {
            border: 'activationActive',
        },
        focused: {
            backgroundColor: 'activationHover',
            textColor: 'activationOnDark',
        },
    },
    plain: {
        inactive: {
            backgroundColor: 'inherit',
            textColor: 'inherit',
            skeletonColor: 'subtle',
        },
        hovered: {},
        active: {},
        pressed: {},
        focused: {},
    },
};
//# sourceMappingURL=buttons.js.map